// Pendiente de revisar
import { DatasetDtoBase } from "../Base/dataset-dto";
import { AccessRightDto } from "../access-rights";
import { AgentDto } from "../agent-dto";
import { CatalogueRecordDto } from "../catalogue-record-dto";
import { Languagev2Dto } from "../language-list-dto";
import { CatalogueArtifactDto } from "./catalogue-artifact-dto";
import { CatalogueCategoryDto } from "./catalogue-category-dto";
import { CatalogueTermDto } from "./catalogue-term-dto";

export class CatalogueDatasetDto extends DatasetDtoBase {
	title: string;
	description: string;
	created: string;
	modified: string;
	issued: string;
	terms: CatalogueTermDto[];
	categories: CatalogueCategoryDto[];
	language: Languagev2Dto;
	creator: string;
	license: null;
	rights: null;
	accessRights: AccessRightDto;
	publisher?: AgentDto;
	owner: AgentDto;
	type: string;
	identifier: null;
	catalogRecord?: CatalogueRecordDto;
	icon: string;
	distributions: CatalogueArtifactDto[];
	byteSize: number;
	datasetId: string;
	score: number;

	constructor(src?: any) {
		super(src);
		Object.assign(this, src);
		this.datasetId = this.id;

		if (this.catalogRecord) {
			this.catalogRecord.description =
				this.catalogRecord.description || this.description || "";
			this.catalogRecord.title = this.catalogRecord.title || this.title || "";
		}
	}
}
